
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { SearchFromMap } from '@/store/application/data.assets';
import NButton from '@/uikit/buttons/NButton.vue';
import NLoadingCircle from '@/uikit/loading/NLoadingCircle.vue';
import ThumbnailItem from '@/components/common/ThumbnailItem.vue';
import { SearchSourceViewModel } from '@/pages/search/SearchSourceViewModel';
import SearchSidebarCard from './SearchSidebarCard.vue';

@Options({
  name: 'SearchSidebar',
  components: { NButton, NLoadingCircle, SearchSidebarCard, ThumbnailItem },
  emits: ['showDetectDialog']
})
export default class SearchSidebar extends Vue {
  @Prop({ type: Object, required: true })
  sourceModule!: SearchSourceViewModel;

  private get state() {
    return this.sourceModule.state;
  }

  get isFile() {
    return this.state.searchFrom === SearchFromMap.File;
  }

  get isCard() {
    return this.state.searchFrom === SearchFromMap.Cards;
  }

  get itemThumbnailAndName() {
    const item = this.sourceModule.sourceItem;
    switch (this.state.searchFrom) {
      case SearchFromMap.Events:
        return { thumbnail: item.thumbnail, name: item.id };
      case SearchFromMap.CaseClusters:
      case SearchFromMap.Clusters:
        return { thumbnail: item.best_event.thumbnail, name: item.id };
      case SearchFromMap.File:
        return { thumbnail: this.sourceModule.bboxThumbnail, name: this.state.id };
      default:
        return {};
    }
  }
}
